// export const disciplineOptionValues = {
//     "Famous Fiction": "famousfiction",
//     "Educational": "education",
//     "Code": "code",
//     "News/History/Real Events": "news_history_realevents",
// }

export const textLabels = {
    1: "A",
    2: "B",
    3: "C",
    4: "D",
}

export const disciplineOptions = [
  { id: 1, label: "famous-fiction", selectionValue: "famousfiction" },
  { id: 2, label: "educational", selectionValue: "education" },
  { id: 3, label: "code", selectionValue: "code" },
  { id: 4, label: "news-real-events", selectionValue: "news_history_realevents" },
  { id: 5, label: "scientific-argumentation", selectionValue: "science" },
  { id: 6, label: "cyber-security", selectionValue: "cyber_security" },
  { id: 7, label: "history", selectionValue: "history" }
];

export const codeLanguageOptions = [
    { id: 1, name: "C", label: "C", selectionValue: "C" },
    { id: 2, name: "C++", label: "C++", selectionValue: "C++" },
    { id: 3, name: "Java", label: "Java", selectionValue: "Java" },
    { id: 4, name: "Python", label: "Python", selectionValue: "Python" },
    { id: 5, name: "C#", label: "C#", selectionValue: "C#" },
    { id: 6, name: "JavaScript", label: "JavaScript", selectionValue: "JavaScript" },
]

export const llmOptions = [
    { id: 1, name: "Grok", label: "Grok", selectionValue: "Grok" },
    { id: 2, name: "Gemini", label: "Gemini", selectionValue: "Gemini" },
    { id: 3, name: "ChatGPT", label: "ChatGPT", selectionValue: "ChatGPT" },
    { id: 4, name: "Copilot", label: "Copilot", selectionValue: "Copilot" },
    { id: 5, name: "Combination", label: "Combination", selectionValue: "Combination" },
]

export const inaccuracyLevelOptions = [
    { id: 1, name: "Minor", label: "minor", selectionValue: "Minor" },
    { id: 2, name: "Medium", label: "medium", selectionValue: "Medium" },
    { id: 3, name: "Major", label: "major", selectionValue: "Major" },
]

export const primarySecondaryOptions = [
    { id: 1, name: "Primary", label: "primary", selectionValue: "Primary" },
    { id: 2, name: "Secondary", label: "secondary", selectionValue: "Secondary" },
]

export const titleDisciplineIds = [
    1
]

export const originalTextDisciplineIds = [
    2, 3, 4
]

export const sciArgTargetAudienceOptions = [
    { id: 1, name: "4th Grade", label: "grade-4", selectionValue: "4" },
    { id: 2, name: "5th Grade", label: "grade-5", selectionValue: "5" },
    { id: 3, name: "6th Grade", label: "grade-6", selectionValue: "6" },
    { id: 4, name: "7th Grade", label: "grade-7", selectionValue: "7" },
    { id: 5, name: "8th Grade", label: "grade-8", selectionValue: "8" },
    { id: 6, name: "9th Grade", label: "grade-9", selectionValue: "9" },
    { id: 7, name: "10th Grade", label: "grade-10", selectionValue: "10" },
    { id: 8, name: "11th Grade", label: "grade-11", selectionValue: "11" },
    { id: 9, name: "12th Grade", label: "grade-12", selectionValue: "12" },
    { id: 10, name: "Undergraduate", label: "grade-undergrad", selectionValue: "undergrad-student" },
    { id: 10, name: "Graduate", label: "grade-grad", selectionValue: "grad-student" },
    { id: 10, name: "PhD", label: "grade-phd", selectionValue: "PhD-student" },
    { id: 10, name: "Adult", label: "grade-adult", selectionValue: "adult" }
]

export const sciArgClaimOptions = [
    { id: 1, name: "1", label: "1", selectionValue: "1" },
    { id: 2, name: "2", label: "2", selectionValue: "2" },
    { id: 3, name: "3", label: "3", selectionValue: "3" },
    { id: 4, name: "4", label: "4", selectionValue: "4" },
    { id: 5, name: "5", label: "5", selectionValue: "5" },
]

export const defaultAvatar = "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=default"